module.exports = __webpack_public_path__ + "img/icon_round_chevron_left.b91c3e33.svg";